module.exports = __webpack_public_path__ + "img/fn-cloth.64afa735.png";